import {form_data_logger} from '../../utils/utilities'

function FormLogger(props: any) {
  form_data_logger(props)
  return <></>
}

export default FormLogger
